import axios, { AxiosError, AxiosInstance } from 'axios';
import _ from 'lodash';
import { StringHelper } from './helpers';

export let axiosApi!: AxiosInstance;
declare var $: any;
export function setupApi(culture: string, token: string) {
	console.log(Zakeke.config);
	axiosApi = axios.create({
		baseURL: Zakeke.config.cloudFlareApiUrl || Zakeke.config.baseApiUrl,
		timeout: 120000,
		withCredentials: true,
		headers: {
			Authorization: 'Bearer ' + token,
			'Accept-Language': culture
		}
	});

	$.ajaxSetup({
		xhrFields: { withCredentials: true },
		headers: {
			Authorization: 'Bearer ' + token,
			'Accept-Language': culture
		}
	});

	axiosApi.interceptors.response.use(
		function (response) {
			// Convert all to camelCase
			if (response.data && (_.isObject(response.data) || _.isArray(response.data))) response.data = StringHelper.pascalToCamel(response.data);

			return response;
		},
		function (error: AxiosError) {
			// Convert all to camelCase
			if (error.response && error.response.data) {
				error.response.data = StringHelper.pascalToCamel(error.response.data);
			}

			return Promise.reject(error);
		}
	);
}
